export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13846.82bb7eb7.jpg";